function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M19.7 39l.6 1.1a.7.7 0 0 0 1.2 0l.7-1.2c.8-1.5 1.2-3.2 1.2-4.9V12.6c0-1.5-.2-3-.6-4.3l-1.9-5.4-1.8 5.4c-.4 1.4-.6 2.8-.6 4.3V34c0 1.7.4 3.4 1.2 5z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M19.7 37v.2c.3.3.7.5 1.2.6h.1c.5 0 .9-.3 1.1-.6V37l.3-.6h-.2l-.3.4a1.4 1.4 0 0 1-1 .4c-.3 0-.6-.1-.8-.3l-.2-.1-.3-.4v.6"
}), React.createElement("path", {
  fill: "#145569",
  d: "M27 27.1h2.4l-.2-2v-1c0-.4-.4-.7-.8-.7h-.7c-.4 0-.8.3-.8.7l-.1 2.6v.4h.2zM26.9 27.6H29.2s.2 0 .2-.2v-.3H26.7v.3c0 .1 0 .2.2.2M31.7 24.6H34s.2 0 .2-.2v-.3H31.5v.3c0 .1 0 .2.2.2"
}), React.createElement("path", {
  fill: "#145569",
  d: "M31.8 24.1h2.4L34 22v-.7c0-.5-.4-.8-.8-.8h-.7c-.4 0-.8.3-.8.8l-.2 2.3v.6h.3zM14.8 27a7 7 0 0 1-2 0h-.3l.1-2v-.8c0-.4.4-.8.8-.8h.7c.5 0 .8.4.8.8l.2 2.5v.4h-.3z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M15 27.6h-.2a7 7 0 0 1-2 0h-.2a.2.2 0 0 1-.1-.2V27h.3a7 7 0 0 0 2 0h.3v.4s0 .2-.2.2M10.2 24.6H10a7 7 0 0 1-2 0H8a.2.2 0 0 1-.2-.2V24H8a7 7 0 0 0 2 0h.4v.3l-.2.2"
}), React.createElement("path", {
  fill: "#145569",
  d: "M10 24a7 7 0 0 1-2 0h-.3l.1-2.1V21c0-.4.4-.7.8-.7h.7c.4 0 .8.3.8.7l.1 2.4v.6H10z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M41.3 14.4l-15.6 4.9-2.3.7v8.5l2.3-1.6L40.6 17z"
}), React.createElement("path", {
  fill: "#B1E4ED",
  d: "M40.6 17L23.4 28.5v-1L41 15.8z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M.5 14.4l15.6 4.9 2.4.7v8.5l-2.4-1.6L1.3 17z"
}), React.createElement("path", {
  fill: "#B1E4ED",
  d: "M1.3 17l17.2 11.5v-1L.9 15.8z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M13.7.8l4.8 2 2.1.9-.1 4.5-2-1.8-4.7-4.1z"
}), React.createElement("path", {
  fill: "#B1E4ED",
  d: "M13.8 2.3l6.7 5.9v-.9l-6.8-5.9z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M28.2.8l-4.8 2-2.2.9.2 4.5 2-1.8 4.7-4.1z"
}), React.createElement("path", {
  fill: "#B1E4ED",
  d: "M28.1 2.3l-6.7 5.9v-.9l6.8-5.9zM21 10a.4.4 0 0 0 .4-.5L21.2.7c0-.1-.1-.2-.3-.2a.2.2 0 0 0-.2.2l-.2 8.8c0 .3.2.5.4.5z"
}));

var SvgPlane = function SvgPlane(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 42 41",
    width: 42,
    height: 41,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane.e6160a5b.svg";
export { ForwardRef as ReactComponent };